// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The header is the shared FeatureHeader component. Contrast: olive on the page 6.28, olive on
   sunken 5.39. All AA. */
.busy-bees {
  --bb-olive: var(--color-olive);
  --bb-panel: #e9eed6; /* sunken green lifted toward the page, for the supplies panel */
  --bb-beige: #f3e9df;
}

.busy-bees h1,
.busy-bees h2,
.busy-bees h3 {
  color: var(--bb-olive);
}

.busy-bees section {
  padding: 28px 0;
}

/* Content sits in one centered column, as in the design. */
.bb-narrow {
  max-width: 760px;
}

.bb-section-heading {
  text-align: center;
  margin-bottom: 24px;
}

.bb-section-heading h2 {
  margin-bottom: 6px;
}

.bb-section-heading p {
  margin: 0;
  font-size: 0.95rem;
}

/* --- We supply everything ------------------------------------------------ */
/* A centered, roughly square panel rather than a full-width band. */
/* A centered, roughly square panel rather than a full-width band. */
.bb-supplies {
  max-width: 600px;
  margin: 0 auto;
  background-color: var(--bb-panel);
  border-radius: 32px;
  padding: 44px 40px;
}

.bb-supplies .bb-section-heading {
  margin-bottom: 36px;
}

.bb-supplies .bb-section-heading h2 {
  font-size: 2rem;
  margin-bottom: 10px;
}

.bb-supply-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 32px;
}

.bb-supply-row {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* Every other row mirrors: icon on the right, text right-aligned. */
.bb-supply-row:nth-child(even) {
  flex-direction: row-reverse;
  text-align: right;
}

.bb-supply-row h3 {
  font-size: 1.2rem;
  margin: 0 0 6px;
}

.bb-supply-row p {
  margin: 0;
}

.bb-icon-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: var(--surface-raised);
  color: var(--text-accent);
  box-shadow: 0 2px 6px rgba(89, 88, 96, 0.14);
}

/* --- What you'll make ---------------------------------------------------- */
.bb-chips {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.bb-chip {
  font-size: 0.9rem;
  font-weight: 600;
  padding: 6px 16px;
  border-radius: 999px;
  border: 1px solid var(--border-subtle);
}

.bb-chip-green {
  background-color: var(--bb-panel);
}

.bb-chip-white {
  background-color: var(--surface-raised);
}

.bb-chip-beige {
  background-color: var(--bb-beige);
}

/* --- Join CTA ------------------------------------------------------------ */
/* "Become a Busy Bee" under the intro jumps down to the form. */
.bb-hero-action {
  text-align: center;
  margin: -8px 0 8px;
}

.bb-hero-action .btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

/* Sign-up form in one centered column, with the questions line under it. */
.busy-bees .bb-join-section {
  padding: 36px 0 64px;
  /* Land below the sticky header when jumped to from #join. */
  scroll-margin-top: 80px;
}

.container.bb-join {
  max-width: 640px;
  text-align: center;
}

.bb-join h2 {
  margin-bottom: 6px;
}

.bb-join > p {
  margin: 0 0 18px;
}

.bb-join .form-card {
  text-align: left;
}

.bb-join .form-card .btn {
  align-self: center;
}

.bb-social {
  justify-content: center;
  margin-top: 28px;
}

@media (max-width: 780px) {
  .bb-supplies {
    padding: 22px 18px;
  }
}

/* Phones: stack instead of squeezing things side by side. */
@media (max-width: 600px) {
  .bb-supplies .bb-section-heading h2 {
    font-size: 1.6rem;
  }

  /* Icon above centered text; the desktop zig-zag leaves too narrow a text
     column at this width. */
  .bb-supply-row,
  .bb-supply-row:nth-child(even) {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .bb-supply-list {
    gap: 28px;
  }

  .bb-icon-circle {
    width: 56px;
    height: 56px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/BusyBees.css"],"names":[],"mappings":"AAAA;yBACyB;AACzB;EACE,8BAA8B;EAC9B,mBAAmB,EAAE,gEAAgE;EACrF,mBAAmB;AACrB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA,8EAA8E;AAC9E,oEAAoE;AACpE,oEAAoE;AACpE;EACE,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,oEAAoE;AACpE;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA,8EAA8E;AAC9E;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,8EAA8E;AAC9E,gEAAgE;AAChE;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,2EAA2E;AAC3E;EACE,oBAAoB;EACpB,4DAA4D;EAC5D,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,iBAAiB;EACnB;;EAEA;4BAC0B;EAC1B;;IAEE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* The header is the shared FeatureHeader component. Contrast: olive on the page 6.28, olive on\n   sunken 5.39. All AA. */\n.busy-bees {\n  --bb-olive: var(--color-olive);\n  --bb-panel: #e9eed6; /* sunken green lifted toward the page, for the supplies panel */\n  --bb-beige: #f3e9df;\n}\n\n.busy-bees h1,\n.busy-bees h2,\n.busy-bees h3 {\n  color: var(--bb-olive);\n}\n\n.busy-bees section {\n  padding: 28px 0;\n}\n\n/* Content sits in one centered column, as in the design. */\n.bb-narrow {\n  max-width: 760px;\n}\n\n.bb-section-heading {\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.bb-section-heading h2 {\n  margin-bottom: 6px;\n}\n\n.bb-section-heading p {\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n/* --- We supply everything ------------------------------------------------ */\n/* A centered, roughly square panel rather than a full-width band. */\n/* A centered, roughly square panel rather than a full-width band. */\n.bb-supplies {\n  max-width: 600px;\n  margin: 0 auto;\n  background-color: var(--bb-panel);\n  border-radius: 32px;\n  padding: 44px 40px;\n}\n\n.bb-supplies .bb-section-heading {\n  margin-bottom: 36px;\n}\n\n.bb-supplies .bb-section-heading h2 {\n  font-size: 2rem;\n  margin-bottom: 10px;\n}\n\n.bb-supply-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 32px;\n}\n\n.bb-supply-row {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n/* Every other row mirrors: icon on the right, text right-aligned. */\n.bb-supply-row:nth-child(even) {\n  flex-direction: row-reverse;\n  text-align: right;\n}\n\n.bb-supply-row h3 {\n  font-size: 1.2rem;\n  margin: 0 0 6px;\n}\n\n.bb-supply-row p {\n  margin: 0;\n}\n\n.bb-icon-circle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background-color: var(--surface-raised);\n  color: var(--text-accent);\n  box-shadow: 0 2px 6px rgba(89, 88, 96, 0.14);\n}\n\n/* --- What you'll make ---------------------------------------------------- */\n.bb-chips {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px;\n}\n\n.bb-chip {\n  font-size: 0.9rem;\n  font-weight: 600;\n  padding: 6px 16px;\n  border-radius: 999px;\n  border: 1px solid var(--border-subtle);\n}\n\n.bb-chip-green {\n  background-color: var(--bb-panel);\n}\n\n.bb-chip-white {\n  background-color: var(--surface-raised);\n}\n\n.bb-chip-beige {\n  background-color: var(--bb-beige);\n}\n\n/* --- Join CTA ------------------------------------------------------------ */\n/* \"Become a Busy Bee\" under the intro jumps down to the form. */\n.bb-hero-action {\n  text-align: center;\n  margin: -8px 0 8px;\n}\n\n.bb-hero-action .btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Sign-up form in one centered column, with the questions line under it. */\n.busy-bees .bb-join-section {\n  padding: 36px 0 64px;\n  /* Land below the sticky header when jumped to from #join. */\n  scroll-margin-top: 80px;\n}\n\n.container.bb-join {\n  max-width: 640px;\n  text-align: center;\n}\n\n.bb-join h2 {\n  margin-bottom: 6px;\n}\n\n.bb-join > p {\n  margin: 0 0 18px;\n}\n\n.bb-join .form-card {\n  text-align: left;\n}\n\n.bb-join .form-card .btn {\n  align-self: center;\n}\n\n.bb-social {\n  justify-content: center;\n  margin-top: 28px;\n}\n\n@media (max-width: 780px) {\n  .bb-supplies {\n    padding: 22px 18px;\n  }\n}\n\n/* Phones: stack instead of squeezing things side by side. */\n@media (max-width: 600px) {\n  .bb-supplies .bb-section-heading h2 {\n    font-size: 1.6rem;\n  }\n\n  /* Icon above centered text; the desktop zig-zag leaves too narrow a text\n     column at this width. */\n  .bb-supply-row,\n  .bb-supply-row:nth-child(even) {\n    flex-direction: column;\n    text-align: center;\n    gap: 12px;\n  }\n\n  .bb-supply-list {\n    gap: 28px;\n  }\n\n  .bb-icon-circle {\n    width: 56px;\n    height: 56px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
